<Loader :loading="loading" />
<CreateEvent />
<div class="d-flex align-items-center temporary-post" v-if="temporary_post" id="temp-post">
    <p class="text-xs fw-bold">{{ temporary_post.document_name }} - Posting...</p>
    <div class="spinner-border ms-auto  text-secondary" role="status" aria-hidden="true"></div>
</div>
<div v-if="events.length">
        <div class="p-2 scroll-container">
            <div class="card p-4 shadow-sm rounded-5 border-0 mb-3" v-for="event in events" :key="event.id" @click.stop>

              <div class="d-flex justify-content-between align-items-start">
                <div>

                  <h5 class="card-title mb-1">
                    <a href="#">{{ event.event_name }}</a>
                  </h5>
                  <small class="text-muted">{{formatDate(event.start_date)}}, {{ event.start_time ?
                    form_time(event.start_time) : "" }} -
                    {{ event.end_time ? form_time(event.end_time) : "" }}</small>
                </div>
                <div v-if="event.is_recurring">
                      <span class="badge bg-secondary text-xs ms-2">Recurring :{{ event.recurring_pattern?.name }}</span>
                    </div>
                <button class="btn btn-sm btn-primary px-3 py-1 shadow" @click.stop="selectEvent(event)"
                  data-bs-toggle="modal" data-bs-target="#eventModal">RSVP</button>
              </div>
              <p class="mt-3 mb-4 text-xs text-muted" v-html="event.description"></p>
              <div class="d-flex flex-wrap gap-2">
                <span class="tag text-xs">{{ daysUntil(event.start_date) }}</span>
                <span class="info-tag text-xs"><i class="bi bi-geo-fill"></i> {{event.location}}</span>
                <span class="info-tag text-xs"><i class="bi bi-person"></i> {{event.organizer}}</span>
                <span
                  v-if="token_exists && String(event.user.id) === String(get_user_id()) || token_exists && user_details.user_role === 'admin'"
                  class="info-tag text-xs" @click="selectEvent(event)" data-bs-toggle="modal"
                  data-bs-target="#exampleModal"><i class="bi bi-people"></i> {{event.rsvp_count}} Attendees</span>
                <div class="dropend float-end mt-1" @click.stop
                  v-if="token_exists && String(event.user.id) === String(get_user_id()) || token_exists && user_details.user_role === 'admin'">
                  <a href="" class="fw-bold text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    <i class="bi bi-three-dots-vertical"></i>
                  </a>
                  <ul v-if="token_exists" class="dropdown-menu custom-dropdown lh-1" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item text-xs border-bottom fw-bold d-none" href=""
                      @click.prevent="togglePinReport(event)">
                      <i :class="event.is_pinned ? 'bx bx-pin fs-6' : 'bx bxs-pin fs-6'"></i>
                      {{ event.is_pinned ? 'Unpin' : 'Pin' }}
                    </a>
                    <li>
                      <a class="dropdown-item text-xs fw-bold" href="" @click.prevent="edit_event(event)">
                        <i class='bx bxs-edit fs-6'></i> Edit
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item text-xs fw-bold" href="" @click.prevent="deleteEvent(event.id)">
                        <i class='bx bxs-trash-alt fs-6'></i> Delete
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
        </div>
</div>
<div v-else class="text-center">No available Events</div>


<div class="modal fade" id="event_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xs fw-500" id="exampleModalLabel">{{ event_id ? 'Edit Event' : 'Create your event'}}
          </p>
          <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="event_id ? update_event() : submit_event_form()">
          <div class="modal-body modal-body-scroll">

            <div class="mb-3">
              <label for="event_name" class="form-label text-xs fw-500">Event Name <span
                  class="text-danger">*</span></label>
              <input type="text" class="form-control rounded-5 text-xs" id="event_name" placeholder="Enter event name"
                v-model="event_name">
              <p v-if="errors.event_name" class="text-danger text-xs">{{ errors.event_name }}</p>
            </div>
            <div class="d-flex flex-row justify-content-between mx-1">
            </div>
            <div class="d-flex flex-row justify-content-between mx-1">
              <div v-if="$route.name !== 'home_filter' && $route.name !== 'view_portal' && !event_id">
                <label for="portals" class="form-label text-xs fw-500"><span class="text-danger">*</span>Tag a portal :
                </label>
                <select class="text-xs btn-primary fw-500 border-0 rounded-5 btn-sm mb-3 border-end"
                  v-model="selectedPortalId" id="portals">
                  <option value="" selected hidden>
                    * Tag a portal
                  </option>
                  <option v-for="portal in portals" :value="portal.id" :key="portal.id">{{ portal.name }}</option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label text-xs fw-500">Event Type <span class="text-danger">*</span></label>
              <div class="d-flex flex-row align-items-center">
                <div v-for="(type, index) in event_types" :key="index" class="form-check me-3">
                  <input type="radio" class="form-check-input" :value="type" v-model="event_type" :id="`${type}_event`"
                    :name="`event_type`" />
                  <label :for="`${type}_event`" class="form-check-label">{{ type.name }}</label>
                </div>
              </div>
              <p v-if="errors.event_type" class="text-danger text-xs">{{ errors.event_type }}</p>
            </div>

            <!-- Recurring Event Section -->
<div class="col-md-6 mb-3">
  <label class="form-label text-xs fw-500">Is Recurring?</label>
  <div class="form-check">
    <input class="form-check-input" type="checkbox" id="is_recurring" v-model="is_recurring" />
    <label class="form-check-label text-xs" for="is_recurring">Repeat this event</label>
  </div>
</div>

<div class="col-md-6 mb-3" v-if="is_recurring">
  <label for="recurring_type" class="form-label text-xs fw-500">Recurrence Pattern <span
      class="text-danger">*</span></label>
  <select class="form-select rounded-5 text-xs" id="recurring_type" v-model="recurring_type">
    <option value="" disabled selected>Select recurrence</option>
    <option v-for="pattern in recurring_patterns" :key="pattern.id" :value="pattern.id">
      {{ pattern.name }}
    </option>
  </select>
  <p v-if="errors.recurring_type" class="text-danger text-xs">{{ errors.recurring_type }}</p>
</div>

            <div class="d-flex mt-2 mx-1 justify-content-between align-items-start">
            <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
              <label for="editdocumentFileInput" class="text-xs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                <i class='bx bx-image-add file-upload-icon'></i> Add event content/agenda
              </label>
              <input type="file" id="editdocumentFileInput" class="file-input d-none" @change="handleFileUpload"/>
              <div v-if="fileName" class="text-xs text-secondary fst-italic mt-1">
                <span class="fw-500">File name:</span> {{fileName }}
              </div>
              <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>
            </div>
          </div>
            <QuillEditor theme="snow" v-model="event_description" ref="quillEventEditorRef" class="quill-editor"
              placeholder="Enter your description here..." toolbar="full" />
            <div class="row">
              <!-- Event Start Date -->
              <div class="col-md-3 mb-3">
                <label for="start_date" class="form-label text-xs fw-500">Event Start Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded-5 text-xs" id="start_date" v-model="start_date">
                <p v-if="errors.start_date" class="text-danger text-xs">{{ errors.start_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                <label for="start_time" class="form-label text-xs fw-500">Start Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded-5 text-xs" id="start_time" v-model="start_time">
                <p v-if="errors.start_time" class="text-danger text-xs">{{ errors.start_time }}</p>
              </div>

              <!-- Event End Date -->
              <div class="col-md-3 mb-3">
                <label for="end_date" class="form-label text-xs fw-500">Event End Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded-5 text-xs" id="end_date" v-model="end_date">
                <p v-if="errors.end_date" class="text-danger text-xs">{{ errors.end_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                <label for="end_time" class="form-label text-xs fw-500">End Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded-5 text-xs" id="end_time" v-model="end_time">
                <p v-if="errors.end_time" class="text-danger text-xs">{{ errors.end_time }}</p>
              </div>

              <!-- RSVP Start Date -->
              <div class="col-md-3 mb-3">
                <label for="rsvp_start_date" class="form-label text-xs fw-500">RSVP Start Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded-5 text-xs" id="rsvp_start_date"
                  v-model="rsvp_start_date">
                <p v-if="errors.rsvp_start_date" class="text-danger text-xs">{{ errors.rsvp_start_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                <label for="rsvp_start_time" class="form-label text-xs fw-500">RSVP Start Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded-5 text-xs" id="rsvp_start_time"
                  v-model="rsvp_start_time">
                <p v-if="errors.rsvp_start_time" class="text-danger text-xs">{{ errors.rsvp_start_time }}</p>
              </div>

              <!-- RSVP End Date -->
              <div class="col-md-3 mb-3">
                <label for="rsvp_end_date" class="form-label text-xs fw-500">RSVP End Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded-5 text-xs" id="rsvp_end_date" v-model="rsvp_end_date">
                <p v-if="errors.rsvp_end_date" class="text-danger text-xs">{{ errors.rsvp_end_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                <label for="rsvp_end_time" class="form-label text-xs fw-500">RSVP End Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded-5 text-xs" id="rsvp_end_time" v-model="rsvp_end_time">
                <p v-if="errors.rsvp_end_time" class="text-danger text-xs">{{ errors.rsvp_end_time }}</p>
              </div>
            </div>

            <div class="mb-3">
              <label for="organizer" class="form-label text-xs fw-500">Organizer <span
                  class="text-danger">*</span></label>
              <input type="text" class="form-control rounded-5 text-xs" id="organizer"
                placeholder="Enter organizer name" v-model="organizer">
              <p v-if="errors.organizer" class="text-danger text-xs">{{ errors.organizer }}</p>
            </div>
            <div v-if="event_type.name === 'online' || event_type.name === 'hybrid'" class="mb-4">
              <label for="event_link" class="form-label text-xs fw-500 d-block">Event Link <span
                  class="text-danger">*</span></label>
              <input id="event_link" type="url" class="form-control rounded-5 text-xs"
                placeholder="Enter event link (e.g., Zoom, Google Meet,Teams)" v-model="event_link" />
              <p v-if="errors.event_link" class="text-danger text-xs">{{ errors.event_link }}</p>
            </div>
            <div v-if="event_type.name !== 'online'" :key="event_type.name" class="mb-4">
              <label for="mapSearchBox" class="form-label text-xs fw-500 d-block">Search for Location</label>
              <input id="mapSearchBox" type="text" class="form-control rounded-5 text-xs"
                placeholder="Search location..." v-model="location" />
              <p v-if="errors.location" class="text-danger text-xs">{{ errors.location }}</p>
            </div>

            <div class="event-extras"v-if="show_add_extras">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h3 class="text-xs fw-500 mb-0">Event Extra</h3>
                <button type="button" class="btn btn-outline-primary btn-sm rounded-5 text-xs"
                  @click.prevent="addExtra">
                  <i class="bx bx-plus"></i>
                  Add Extra Item
                </button>
              </div>

              <div id="extraItemsList" class="mt-3">
              </div>
            </div>

          </div>

          <div class="container mt-4"  v-if="showExtrasForm && show_add_extras && extraForms.length > 0">
            <div v-for="(extraForm, extraIndex) in extraForms" :key="extraIndex" id="select_extra_container"
              class="border rounded-3 p-3 mt-3 bg-light">

              <input v-model="extraForm.id" type="text"  class="d-none extra_form_id">

              <div class="mb-3">
                <label class="form-label text-xs fw-500">Select Extra:</label>
                <input type="text" class="form-control selectExtra" v-model="extraForm.selectedExtra"
                  placeholder="Enter or select extra" :list="'extrasList-' + extraIndex">
                <datalist :id="'extrasList-' + extraIndex">
                  <option v-for="extra in availableExtras" :key="extra.id" :value="extra.name"></option>
                </datalist>
              </div>

              <div v-for="(item, itemIndex) in extraForm.items" :key="itemIndex + '_extra'"
                class="border rounded-3 p-2 mb-2 bg-white">

                <input v-model="item.id" type="text" class="d-none item_id">

                <div class="mb-2">
                  <label class="form-label text-xs fw-500">Item Name:</label>
                  <input v-model="item.item_name" type="text" class="form-control rounded-5 text-xs item_name"
                    placeholder="Enter item name">
                </div>


                <div class="mb-2">
                  <label class="form-label text-xs fw-500">Description:</label>
                  <textarea v-model="item.item_description" type="text" class="form-control rounded-3 text-xs item_description" rows="2"
                    placeholder="Enter description"></textarea>
                </div>


                <div class="mb-2">
                  <label class="form-label text-xs fw-500">Price:</label>
                  <input v-model="item.item_price" type="number" class="form-control rounded-5 text-xs item_price"
                    placeholder="0.00" step="0.01" min="0">
                </div>


                <button @click.prevent="removeExtraItem(extraIndex, itemIndex)" class="btn btn-danger btn-sm">
                  <i class="bx bx-trash"></i>
                </button>
              </div>


              <button @click.prevent="addExtraItem(extraIndex)" class="btn btn-outline-success btn-sm mt-2">
                + Add Extra Item
              </button>


              <button @click.prevent="removeExtra(extraIndex)" class="btn btn-danger btn-sm mt-2">
                Remove Extra
              </button>

            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded-5">{{ event_id ? 'Update' : 'Save' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>